import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import CheckRectangular from "@assets/illustrations/check_rectangular_l18.svg?react";
import { Dialog, FontWeights, SvgIcon, Text } from "@flat-ui";
/**
 * Render a dialog to show the success message after the user has requested a quote.
 */
export function QuoteSuccessDialog(t0) {
  const $ = _c(6);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text variant="heading32" component="div" sx={{
      fontWeight: FontWeights.Regular,
      textAlign: "center",
      width: "100%",
      whiteSpace: "pre-line"
    }}>Thank you,{"\n"}your request has been sent.</Text>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      py: "52px",
      width: "100%"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Stack sx={t2}><SvgIcon source={CheckRectangular} sx={{
        width: "84px",
        height: "84px"
      }} /></Stack>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Text variant="bodyM" component="div" sx={{
      textAlign: "center",
      width: "100%"
    }}>We'll provide the details within 1-2 business days.</Text>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClose) {
    t5 = <Dialog open={true} title=" " size="l" onClose={onClose} onConfirm={onClose} confirmText="Ok">{t1}{t3}{t4}</Dialog>;
    $[4] = onClose;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}